import InvoiceRegistry from "./InvoiceRegistry.container";

export default InvoiceRegistry;
